import avatar from "../../../../images/avatar.png";
import avatar2 from "../../../../images/avatar2.png";
import avatar3 from "../../../../images/avatar3.png";
import avatar4 from "../../../../images/avatar4.png";
import avatar5 from "../../../../images/avatar5.png";
import avatar6 from "../../../../images/avatar6.png";
import avatar7 from "../../../../images/avatar7.png";
import avatar8 from "../../../../images/avatar8.png";
import avatar9 from "../../../../images/avatar9.png";

export type TReview = {
    id: number;
    name: string;
    role: string;
    organization: string;
    review: string;
    image: string;
};

export const REVIEWS: TReview[] = [
  {
    id: 1,
    name: "Fatima Khalil",
    role: "Chief Compliance Officer",
    organization: "TrustCore Banking",
    review:
      "We went from scattered training spreadsheets to a streamlined, trackable system. The platform is intuitive, the content is always current, and our auditors were impressed.",
    image: avatar,
  },
  {
    id: 2,
    name: "James Taubman",
    role: "Director of Risk & Controls",
    organization: "CapitalEdge Banking",
    review:
      "Most training tools feel generic. Vidda Hub clearly understands the regulatory needs of financial institutions — and makes our job easier.",
    image: avatar2,
  },
  {
    id: 3,
    name: "Marcus Bell",
    role: "Internal Audit Lead",
    organization: "First Regional Trust",
    review:
      "Our team actually enjoys using Vidda Hub. The interface is clean, and the courses are short, sharp, and relevant to what we face on the job every day.",
    image: avatar3,
  },
  {
    id: 4,
    name: "David Lin",
    role: "VP of Regulatory Affairs",
    organization: "Nexus Credit Union",
    review:
      "The automation features are fantastic. Risk scoring and reporting used to take days — now it's just a few clicks.",
    image: avatar4,
  },
  {
    id: 5,
    name: "Liam Anders",
    role: "Operations Risk Officer",
    organization: "CapSecure Alliance",
    review:
      "Vidda brought consistency to our compliance reviews across regional teams. It's now part of our core stack.",
    image: avatar5,
  },
  {
    id: 6,
    name: "Fatima Khalil",
    role: "Compliance Strategy Lead",
    organization: "BlueRiver Capital",
    review:
      "We can track progress across business units in real-time. It's made cross-department compliance much easier.",
    image: avatar6,
  },
  {
    id: 7,
    name: "Elena Popova",
    role: "Senior Policy Advisor",
    organization: "EverBank Group",
    review:
      "Vidda Hub stays ahead of regulatory changes. It’s reassuring to know our assessments reflect current expectations.",
    image: avatar7,
  },
  {
    id: 8,
    name: "Tom Richards",
    role: "Risk Assessment Coordinator",
    organization: "United Financial",
    review:
      "The level of customization we get in assessment templates is outstanding. It fits our specific needs perfectly.",
    image: avatar8,
  },
  {
    id: 9,
    name: "Andre Miller",
    role: "Audit & Controls Specialist",
    organization: "Sentry National Bank",
    review:
      "Vidda Hub helped us move from reactive to proactive when it comes to risk-based reviews.",
    image: avatar9,
  },
] as const;
